import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "transparent-overlay",
  ref: "marqueeOverlayContainer",
  "aria-hidden": true
}
const _hoisted_2 = {
  class: "marquee",
  ref: "marqueeContent"
}
const _hoisted_3 = {
  key: 1,
  "aria-hidden": true,
  class: "marquee"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.ready)
    ? (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["vue3-marquee", { vertical: _ctx.vertical, horizontal: !_ctx.vertical }]),
        style: _normalizeStyle(_ctx.getCurrentStyle),
        key: _ctx.componentKey,
        onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hoverStarted && _ctx.hoverStarted(...args))),
        onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hoverEnded && _ctx.hoverEnded(...args))),
        onMousedown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mouseDown && _ctx.mouseDown(...args))),
        onMouseup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.mouseUp && _ctx.mouseUp(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, null, 512),
        (_ctx.showGradient)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              "aria-hidden": true,
              class: _normalizeClass(["overlay", { vertical: _ctx.vertical, horizontal: !_ctx.vertical }])
            }, null, 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ], 512),
        (!_ctx.animateOnOverflowOnly || (_ctx.animateOnOverflowOnly && !_ctx.animateOnOverflowPause))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "default")
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneAmount, (num) => {
          return (_openBlock(), _createElementBlock("div", {
            "aria-hidden": true,
            class: "marquee cloned",
            key: num
          }, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        }), 128))
      ], 38))
    : _createCommentVNode("", true)
}